var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as actions from 'app/actions/issue';
import http from 'app/services/http';
const defaultSort = config.issueColumns[1];
const initialState = {
    items: [],
    typeItems: [],
    transportItem: null,
    selectedItem: null,
    sortSelectedItem: { name: defaultSort.name, order: defaultSort.order },
    searchValue: '',
};
export const issueReducer = (state = initialState, action) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    switch (action.type) {
        case 'ISSUE_SET_ITEMS': {
            const { items } = (_a = action.payload) !== null && _a !== void 0 ? _a : {};
            return Object.assign(Object.assign({}, state), { items: (_b = items) !== null && _b !== void 0 ? _b : state.items });
        }
        case 'ISSUE_SET_SELECTED_ITEM': {
            const { data } = (_c = action.payload) !== null && _c !== void 0 ? _c : {};
            return Object.assign(Object.assign({}, state), { selectedItem: (_d = data) !== null && _d !== void 0 ? _d : null });
        }
        case 'ISSUE_SET_SEARCH_VALUE': {
            const { value } = (_e = action.payload) !== null && _e !== void 0 ? _e : {};
            return Object.assign(Object.assign({}, state), { searchValue: value !== null && value !== void 0 ? value : '' });
        }
        case 'ISSUE_SET_SORT_SELECTED_ITEM': {
            const data = (_f = action.payload) === null || _f === void 0 ? void 0 : _f.data;
            if (!data) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { sortSelectedItem: {
                    name: data.name,
                    order: state.sortSelectedItem.name !== data.name ? data.order : state.sortSelectedItem.order === 'ASC' ? 'DESC' : 'ASC',
                } });
        }
        case 'ISSUE_ADD_ITEM': {
            const data = (_g = action.payload) === null || _g === void 0 ? void 0 : _g.data;
            if (!data) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { items: [...state.items, data], selectedItem: data });
        }
        case 'ISSUE_UPDATE_ITEM': {
            const data = (_h = action.payload) === null || _h === void 0 ? void 0 : _h.data;
            if (!data) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { selectedItem: data, items: state.items.map((value) => { var _a; return (value.id !== ((_a = state.selectedItem) === null || _a === void 0 ? void 0 : _a.id) ? value : data); }) });
        }
        case 'ISSUE_SET_TRANSPORT_ITEM': {
            const { data } = (_j = action.payload) !== null && _j !== void 0 ? _j : {};
            return Object.assign(Object.assign({}, state), { transportItem: data ? Object.assign(Object.assign({}, state.transportItem), data) : null });
        }
        case 'ISSUE_SET_TYPE_ITEMS': {
            const { items } = (_k = action.payload) !== null && _k !== void 0 ? _k : {};
            return Object.assign(Object.assign({}, state), { typeItems: (_l = items) !== null && _l !== void 0 ? _l : state.typeItems });
        }
        default:
            return state;
    }
};
export function issueLoad() {
    return function issueLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/issue');
            return dispatch(actions.setItems(data));
        });
    };
}
export function issueTypeFormLoad() {
    return function issueTypeFormLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/issue/type');
            return dispatch(actions.setTypeItems(data));
        });
    };
}
export function issueCreate(params) {
    return function issueCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post('/issue', params);
            return dispatch(actions.addItem(data));
        });
    };
}
export function issueStatusUpdate(id, params) {
    return function issueStatusUpdateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.put(`/issue/${id}`, params);
            return dispatch(actions.updateItem(data));
        });
    };
}
export default issueReducer;
